import React from "react";
import { useState, useEffect } from "react";
import "../styles/styles.css";
import { Link } from "react-router-dom";
import CardText from "../components/CardText";

const Home = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Run once to ensure it's accurate even after initial render
    handleResize();

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (isMobile) {
    return (
      <div className="mobile-home-page-wrapper">
        <div className="mobile-home-page-hero-text-wrapper">
          <div className="mobile-home-page-hero-text">Integrity</div>
          <div className="mobile-home-page-hero-text">Accuracy.</div>
          <div className="mobile-home-page-hero-text">Business Assurance.</div>
        </div>
        <div className="mobile-home-page-cards-wrapper">
          <div className="mobile-home-page-card-wrapper">
            <div className="mobile-home-page-card-title">Services</div>
            <div className="mobile-home-page-card-img-wrapper">
              <Link to="/Services">
                <img
                  className="mobile-home-page-card"
                  src="/Stock Images/group-photo.jpg"
                  alt="Us"
                />
              </Link>
            </div>
          </div>
          <div className="mobile-home-page-card-wrapper">
            <div className="mobile-home-page-card-title">About Us</div>
            <div className="mobile-home-page-card-img-wrapper">
              <Link to="/about">
                <img
                  className="mobile-home-page-card"
                  src="/Stock Images/group-photo.jpg"
                  alt="Us"
                />
              </Link>
            </div>
          </div>

          <div className="mobile-home-page-card-wrapper">
            <div className="mobile-home-page-card-title">Meet Our Team</div>
            <div className="mobile-home-page-card-img-wrapper">
              <Link to="/team">
                <img
                  className="mobile-home-page-card"
                  src="/Stock Images/group-photo.jpg"
                  alt="Us"
                />
              </Link>
            </div>
          </div>
          <div className="mobile-home-page-card-wrapper">
            <div className="mobile-home-page-card-title">Insights</div>
            <div className="mobile-home-page-card-img-wrapper">
              <Link to="/insights">
                <CardText type="updates" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <div className="page-hero-text-wrapper">
        <div className="page-hero-text">
          Integrity. Accuracy. Business Assurance.
        </div>
      </div>
      <div className="page-body-wrapper">
        <div className="home-page-cards-wrapper">
          <div className="home-page-card-wrapper">
            <div className="home-page-card-title">Services</div>
            <div className="home-page-card-img-wrapper">
              <Link to="/Services">
                <img
                  className="home-page-card"
                  src="/Stock Images/group-photo.jpg"
                  alt="Us"
                />
              </Link>
            </div>
          </div>
          <div className="home-page-card-wrapper">
            <div className="home-page-card-title">About Us</div>
            <div className="home-page-card-img-wrapper">
              <Link to="/about">
                <img
                  className="home-page-card"
                  src="/Stock Images/group-photo.jpg"
                  alt="Us"
                />
              </Link>
            </div>
          </div>

          <div className="home-page-card-wrapper">
            <div className="home-page-card-title">Meet Our Team</div>
            <div className="home-page-card-img-wrapper">
              <Link to="/team">
                <img
                  className="home-page-card"
                  src="/Stock Images/group-photo.jpg"
                  alt="Us"
                />
              </Link>
            </div>
          </div>
          <div className="home-page-card-wrapper">
            <div className="home-page-card-title">Insights</div>
            <div className="home-page-card-img-wrapper">
              <Link to="/insights">
                <CardText type="updates" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
